import api from 'api/api';
import serverCall from 'api/serverCall';
import { createContext, ReactElement, useContext, useEffect, useState } from 'react';
import { StatusContextType } from 'types/custom/data';

import { useFirebaseContext } from './FirebaseContext';

const StatusContext = createContext<StatusContextType | null>(null);

export const StatusContextProvider = ({ children }: { children: ReactElement }) => {
  const { isLoggedIn } = useFirebaseContext();
  const [serverStatus, setServerStatus] = useState<boolean>(true);
  const [kiteStatus, setKiteStatus] = useState<boolean>(true);
  const [liveTickServerStatus, setLiveTickServerStatus] = useState<boolean>(true);
  const [tickKiteStatus, setTickKiteStatus] = useState<boolean>(false);

  const checkServerHealth = async () => {
    serverCall.get(api.checkServerHealth(), (response, error) => {
      if (response) {
        setServerStatus(true);
        setKiteStatus(response.tickConnected);
      } else {
        setServerStatus(false);
      }
    });
  };

  const checkTickServerHealth = async () => {
    serverCall.get(api.checkTickServerhealth(), (response, error) => {
      if (response) {
        setLiveTickServerStatus(true);
        setTickKiteStatus(response.tickConnected)
      } else {
        setLiveTickServerStatus(false);
      }
    });
  };

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isLoggedIn) {
      checkServerHealth();
      checkTickServerHealth();
      interval = setInterval(() => {
        checkServerHealth();
        checkTickServerHealth();
      }, 10000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isLoggedIn]);

  useEffect(() => {
    serverCall.get(api.getZerodhaKiteConnectStatus(), (response, error) => {
      if (error) {
        console.error(error);
      } else {
        setKiteStatus(response.connected);
      }
    });
  }, []);

  return <StatusContext.Provider value={{ serverStatus, kiteStatus, setKiteStatus, liveTickServerStatus, tickKiteStatus }}>{children}</StatusContext.Provider>;
};

export const useStatusContext = () => {
  const context = useContext(StatusContext);
  if (!context) {
    throw new Error('useStatusContext must be used within a StatusContextProvider');
  }
  return context;
};
export default StatusContext;
